// DENTAL MARKING
// 1. user can select single or multitple teeth,
// every teeth has their own subconditions and surfaces

// 1.1. if user select tooth or teeth and the conditon is RF
// it will show all his sub conditions, and every condition will have surefaces.
// user can select all surfaces for that tooth or teeth, for a single sub condition,
// or user can select that surfaces or another condition as well,
// for example if surfaces or 5, then user can select all for single sub condition,
// Or 2 surfaces for one sub condition, and 3 for others, and if all surfaces are selected
// then anothr sub condition will not be allowed.

// 1.2. if user select tooth or teeth and the conditon is RC
// then user can select only one sub conditions, there will be no surfaces selection

// 1.3. if user select tooth or teeth and the conditon is RE
//  then there will be pulp, and canales.
//  user can select pulp and canales both at a time,
// if pulp is selected, then there will be no surfaces or any thing else.
// if user can select root cancel, then it will have another options for selecting sub canals
//  based on tooth or teeth selection,
//  some will have 1, or 2 or 3 or 4 canals.

// 2  Quadrant selections.
// user can select quadrant as well, but if quadraant is selected, then teeth will be disable,
// and only in conditions the landMark condition will be enable, and the rest will be disabled
// untill the quadrant marking is completed.

// 3 Conditions selection
// if condition type is M-I(missing inplant) then the user will add
// a serial number for the sub condition as well but for only inplant sub condition.

// 4 add observation
//  user can add observations for quadrant or tooth and save for adding record.

import {
  TOOTH_SELECTION,
  SELECTION_COMPLETED,
  CLEAR_DENTAL_RECORD_DATA,
  SET_DENTAL_RECORD_TO_UPDATE,
  QUADRANT_SELECTION,
  ADD_QUADRANT_OBSERVATION,
  ADD_TOOTH_OBSERVATION,
  TOOTH_TOGGLE_SELECTION,
  QUADRANT_TOGGLE_SELECTION,
  CONDITION_AND_SUB_CONDITION_SELECTION,
  CONDITION_AND_SUB_CONDITION_SELECTION_FOR_QUADRANT,
  QUADRANT_SELECTION_COMPLETED,
  DELETE_QUADRANT_OBSERVATION,
  DELETE_TOOTH_OBSERVATION,
  CLEAR_TEMPOBJECT_AND_TEM_QUADRANT,
  RECORD_ADD_OR_UPDATE_TYPE,
  MARK_ALL_SELECTION,
  RESET_ALL_SELECTION,
  UPDATE_TOOTH_OBSERVATION,
  UPDATE_QUADRANT_OBSERVATION,
  EDIT_TOOTH_OR_QUADRANT_OBSERVATION_FROM_LIST,
  RESET_CURRENT_INDENTIFICATION_TEETH,
  RESET_CURRENT_INDENTIFICATION_QUADRANT,
} from "../actions/dentalRecordAction";

const initialState = {
  markedTeeth: [
    {
      id: 1, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",
      marked_completed: false,
    },
    {
      id: 2, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 3, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 4, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 5, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 6, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 7, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 8, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },

    {
      id: 9, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 10, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 11, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 12, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 13, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 14, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 15, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 16, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 17, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 18, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 19, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 20, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 21, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 22, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 23, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 24, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 25, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 26, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 27, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 28, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 29, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 30, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 31, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
    {
      id: 32, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      conditions: [],
      subConditions: [],
      observation: "",

      marked_completed: false,
    },
  ],
  quadrants: [
    {
      identifier: "ur",
      quadrant: "",
      conditions: [],
      observation: "",
      marked_completed: false,
      subConditions: [],
    },
    {
      identifier: "ul",
      quadrant: "",
      conditions: [],
      observation: "",
      marked_completed: false,
      subConditions: [],
    },
    {
      identifier: "lr",
      quadrant: "",
      conditions: [],
      observation: "",
      marked_completed: false,
      subConditions: [],
    },
    {
      identifier: "ll",
      quadrant: "",
      conditions: [],
      observation: "",
      marked_completed: false,
      subConditions: [],
    },
  ],
  tempTeeth: [],
  tempQuadrant: [],

  tempObject: {
    conditions: [], // Array of conditions that can be updated dynamically
    subConditions: [],
  },
  tempQuadrantObject: {
    conditions: [],
    subConditions: [],
  },
  currentTooth: null,
  currentQuadrant: "",
  isRecordUpdate: false,
};

export default function dentalRecordReducer(state = initialState, action) {
  switch (action.type) {
    // case TOOTH_TOGGLE_SELECTION:
    //   const toothId = action.payload;
    //   const isSelected = state.tempTeeth.includes(toothId);

    //   // Find the selected tooth in markedTeeth
    //   const selectedTooth = state.markedTeeth.find(
    //     (tooth) => tooth.id === toothId
    //   );

    //   return {
    //     ...state,
    //     tempTeeth: state.isRecordUpdate
    //       ? isSelected
    //         ? [] // If unselecting in update mode, clear selection (single selection mode)
    //         : [toothId] // Otherwise, select the tooth
    //       : isSelected
    //       ? state.tempTeeth.filter((id) => id !== toothId) // Remove if already selected
    //       : [...state.tempTeeth, toothId], // Add if not selected (multiple selection allowed)

    //     tempObject: state.isRecordUpdate
    //       ? isSelected
    //         ? { conditions: [], subConditions: [], observation: "" } // Clear when unselecting
    //         : selectedTooth
    //         ? {
    //             conditions: selectedTooth.conditions || [],
    //             subConditions: selectedTooth.subConditions || [],
    //             observation: selectedTooth.observation || "",
    //           }
    //         : state.tempObject
    //       : state.tempObject, // Keep existing tempObject if not updating
    //   };
    case TOOTH_TOGGLE_SELECTION:
      const toothId = action.payload;
      const isSelected = state.tempTeeth.includes(toothId);

      // Find the selected tooth in markedTeeth
      const selectedTooth = state.markedTeeth.find(
        (tooth) => tooth.id === toothId
      );

      let _updatedTempTeeth, updatedTempObject;

      if (state.isRecordUpdate) {
        _updatedTempTeeth = isSelected ? [] : [toothId];
        updatedTempObject = isSelected
          ? { conditions: [], subConditions: [], observation: "" }
          : selectedTooth
          ? {
              conditions: selectedTooth.conditions || [],
              subConditions: selectedTooth.subConditions || [],
              observation: selectedTooth.observation || "",
            }
          : state.tempObject;
      } else {
        // Add mode → allow multiple selection
        _updatedTempTeeth = isSelected
          ? state.tempTeeth.filter((id) => id !== toothId)
          : [...state.tempTeeth, toothId];

        updatedTempObject = selectedTooth
          ? {
              conditions: selectedTooth.conditions || [],
              subConditions: selectedTooth.subConditions || [],
              observation: selectedTooth.observation || "",
            }
          : state.tempObject;
      }

      return {
        ...state,
        tempTeeth: _updatedTempTeeth,
        tempObject: updatedTempObject,
      };

    case QUADRANT_TOGGLE_SELECTION:
      const quadrantId = action.payload;
      const isQuadrantSelected = state.tempQuadrant.includes(quadrantId);

      // Find the selected quadrant in markedQuadrants
      const selectedQuadrant = state.quadrants.find(
        (quadrant) => quadrant.identifier === quadrantId
      );

      return {
        ...state,
        tempQuadrant: state.isRecordUpdate
          ? isQuadrantSelected
            ? [] // If unselecting in update mode, clear selection (single selection mode)
            : [quadrantId] // Otherwise, select the quadrant
          : isQuadrantSelected
          ? state.tempQuadrant.filter((id) => id !== quadrantId) // Remove if already selected
          : [...state.tempQuadrant, quadrantId], // Add if not selected

        tempQuadrantObject: state.isRecordUpdate
          ? isQuadrantSelected
            ? { conditions: [], subConditions: [] } // Clear when unselecting
            : selectedQuadrant
            ? {
                conditions: selectedQuadrant.conditions || [],
                subConditions: selectedQuadrant.subConditions || [],
              }
            : state.tempQuadrantObject
          : state.tempQuadrantObject, // Keep existing tempQuadrantObject if not updating
      };

    case CONDITION_AND_SUB_CONDITION_SELECTION:
      return {
        ...state,
        tempObject: {
          ...state.tempObject, // Preserve existing values
          ...(action.payload.conditions && {
            conditions: action.payload.conditions, // Update conditions array
          }),
          ...(action.payload.subConditions && {
            subConditions: action.payload.subConditions, // Update subConditions array
          }),
        },
      };

    case SELECTION_COMPLETED:
      const _updatedmarkedTeeth = state.markedTeeth.map((tooth) => {
        if (state.tempTeeth.includes(tooth.id)) {
          const newConditions = state.tempObject.conditions.filter(
            (condition) =>
              condition.condition_id &&
              condition.condition_type &&
              condition.condition_identifier
          );

          const newSubConditions = state.tempObject.subConditions.filter(
            (subCondition) => subCondition.condition_id
          );

          let updatedConditions = [...tooth.conditions]; // Start with existing conditions

          // Separate existing restored conditions
          const existingRestored = updatedConditions.filter(
            (condition) => condition.condition_type === "restored"
          );

          // Separate incoming restored conditions
          const incomingRestored = newConditions.filter(
            (condition) => condition.condition_type === "restored"
          );

          // Handle incoming restored conditions
          if (incomingRestored.length > 0) {
            // If restored conditions are incoming, remove any non-restored conditions
            updatedConditions = updatedConditions.filter(
              (cond) => cond.condition_type === "restored"
            );

            incomingRestored.forEach((newCond) => {
              const newIdentifier = newCond.condition_identifier;
              updatedConditions = updatedConditions.filter(
                (cond) => cond.condition_identifier !== newIdentifier
              );
              if (newIdentifier === "R-R") {
                // R-R should be added only if R-F or R-C exists
                if (
                  existingRestored.some(
                    (cond) =>
                      cond.condition_identifier === "R-F" ||
                      cond.condition_identifier === "R-C"
                  )
                ) {
                  updatedConditions.push(newCond);
                } else {
                  // If no R-F or R-C exists, replace any existing restored conditions
                  updatedConditions = updatedConditions.filter(
                    (cond) =>
                      cond.condition_identifier !== "R-F" &&
                      cond.condition_identifier !== "R-C" &&
                      cond.condition_identifier !== "R-R"
                  );
                  updatedConditions.push(newCond);
                }
              } else if (newIdentifier === "R-F" || newIdentifier === "R-C") {
                // R-F and R-C should replace each other if needed
                updatedConditions = updatedConditions.filter(
                  (cond) =>
                    cond.condition_identifier !== "R-F" &&
                    cond.condition_identifier !== "R-C"
                );
                updatedConditions.push(newCond);
              }
            });
          }

          // Handle incoming non-restored conditions (replace old conditions)
          const incomingOtherConditions = newConditions.filter(
            (condition) => condition.condition_type !== "restored"
          );

          console.log(
            ">>>>>>>>>>>>>>incomingOtherConditions",
            incomingOtherConditions
          );

          if (incomingOtherConditions.length > 0) {
            // If non-restored conditions are incoming, replace any existing conditions
            updatedConditions = [];
            const latest =
              incomingOtherConditions[incomingOtherConditions.length - 1];

            // Add the new non-restored condition
            updatedConditions.push(latest);
          }

          return {
            ...tooth,
            tooth_id: tooth.id,
            conditions: updatedConditions,
            subConditions: newSubConditions,
            observation: state.tempObject.observation || tooth.observation,
            marked_completed: true,
          };
        }
        return tooth;
      });

      return {
        ...state,
        markedTeeth: _updatedmarkedTeeth, // Update markedTeeth array
        tempTeeth: [], // Clear tempTeeth after updating
        tempObject: {
          conditions: [],
          subConditions: [], // Reset subConditions to initial state
        }, // Reset tempObject
      };

    case CLEAR_TEMPOBJECT_AND_TEM_QUADRANT:
      return {
        ...state,
        tempTeeth: [], // Clear tempTeeth after updating
        tempQuadrant: [],
        tempObject: {
          conditions: [],
          subConditions: [], // Reset subConditions to its initial state
        },
        tempQuadrantObject: {
          conditions: [],
          subConditions: [],
        },
      };

    case CONDITION_AND_SUB_CONDITION_SELECTION_FOR_QUADRANT:
      return {
        ...state,
        tempQuadrantObject: {
          ...state.tempQuadrantObject, // Preserve existing values
          ...(action.payload.conditions && {
            conditions: action.payload.conditions, // Update conditions array
          }),
          ...(action.payload.subConditions && {
            subConditions: [...action.payload.subConditions], // Update subConditions array
          }),
        },
      };

    case QUADRANT_SELECTION_COMPLETED:
      if (state.tempQuadrantObject.conditions.length > 0) {
        const updatedQuadrants = state.quadrants.map((quadrant) => {
          if (state.tempQuadrant.includes(quadrant.identifier)) {
            if (state.isRecordUpdate) {
              // ✅ Logic for updating (removes old subConditions)
              const updatedConditions = quadrant.conditions.map((condition) => {
                const matchingCondition =
                  state.tempQuadrantObject.conditions.find(
                    (tempCondition) =>
                      tempCondition.condition_identifier ===
                      condition.condition_identifier
                  );

                return matchingCondition
                  ? { ...condition, ...matchingCondition } // Update matching condition
                  : condition;
              });

              // Add new conditions if not already present
              const newConditions = state.tempQuadrantObject.conditions.filter(
                (tempCondition) =>
                  !updatedConditions.some(
                    (condition) =>
                      condition.condition_identifier ===
                      tempCondition.condition_identifier
                  )
              );

              return {
                ...quadrant,
                quadrant: quadrant?.identifier,
                marked_completed: true,
                conditions: [...updatedConditions, ...newConditions], // Merge updated & new conditions
                subConditions: [...state.tempQuadrantObject.subConditions], // ✅ REPLACES instead of merging (fix removal)
              };
            } else {
              // ✅ Fixing issue for new record (Merge subConditions)
              const updatedConditions = quadrant.conditions.map((condition) => {
                const matchingCondition =
                  state.tempQuadrantObject.conditions.find(
                    (tempCondition) =>
                      tempCondition.condition_identifier ===
                      condition.condition_identifier
                  );

                return matchingCondition
                  ? { ...condition, ...matchingCondition }
                  : condition;
              });

              // Add new conditions if not already present
              const newConditions = state.tempQuadrantObject.conditions.filter(
                (tempCondition) =>
                  !updatedConditions.some(
                    (condition) =>
                      condition.condition_identifier ===
                      tempCondition.condition_identifier
                  )
              );

              return {
                ...quadrant,
                quadrant: quadrant?.identifier,
                marked_completed: true,
                conditions: [...updatedConditions, ...newConditions],
                subConditions: [
                  ...new Set([
                    ...quadrant.subConditions,
                    ...state.tempQuadrantObject.subConditions,
                  ]),
                ], // ✅ FIX: Now merges subConditions instead of replacing for new records
              };
            }
          }
          return quadrant;
        });

        return {
          ...state,
          quadrants: updatedQuadrants,
          tempQuadrantObject: { conditions: [], subConditions: [] }, // Clear tempQuadrantObject
          tempQuadrant: [],
        };
      }
      return state;

    case TOOTH_SELECTION:
      const tooth_id = action.payload; // Destructure tooth_id and index
      return {
        ...state,
        currentTooth: tooth_id, // Save the selected tooth's ID as reference
        markedTeeth: state.markedTeeth.map(
          (tooth) =>
            tooth.id === tooth_id // Check if the index matches the selected tooth's index
              ? { ...tooth, tooth_id: tooth_id } // Update that tooth
              : tooth // Keep the other teeth unchanged
        ),
      };

    case CLEAR_DENTAL_RECORD_DATA:
      // return initialState;
      return JSON.parse(JSON.stringify(initialState)); // Deep copy

      break;

    case SET_DENTAL_RECORD_TO_UPDATE:
      return {
        ...state,
        markedTeeth: state.markedTeeth.map(
          (tooth) =>
            action.payload.data.find(
              (updatedTooth) => updatedTooth.id === tooth.id
            ) || tooth
        ),
        quadrants: state.quadrants.map(
          (quadrant) =>
            action.payload?.quadrantData.find(
              (updatedQuadrant) =>
                updatedQuadrant.identifier === quadrant.identifier
            ) || quadrant
        ),
      };
      break;

    case QUADRANT_SELECTION:
      const quadrant = action.payload;
      return {
        ...state,
        quadrants: state.quadrants.map((_quadrant) =>
          _quadrant.identifier === quadrant
            ? {
                ..._quadrant,
                quadrant: _quadrant.quadrant === quadrant ? "" : quadrant, // Toggle selection
              }
            : _quadrant
        ),
      };
      break;

    case ADD_QUADRANT_OBSERVATION:
      const { observation } = action?.payload;

      const _updatedMarkedQuadrantArray = state.quadrants.map((quadrant) => {
        if (state.tempQuadrant.includes(quadrant.identifier)) {
          return {
            ...quadrant,
            observation: observation,
            quadrant: quadrant.identifier, // if you still want to explicitly set this
          };
        }
        return quadrant;
      });

      return {
        ...state,
        quadrants: _updatedMarkedQuadrantArray,
        tempQuadrant: [],
      };

    case UPDATE_QUADRANT_OBSERVATION:
      const { q_id, q_observation } = action.payload;
      const _updatedObservationMarkedQuadrant = state.quadrants.map(
        (quadrant) => {
          if (state.tempQuadrant.includes(quadrant?.identifier)) {
            return {
              ...quadrant,
              observation: q_observation,
              quadrant: quadrant.identifier, // Update the observation for the specific tooth
            };
          }
          return quadrant;
        }
      );
      console.log(
        "_updatedObservationMarkedQuadrant",
        _updatedObservationMarkedQuadrant
      );
      return {
        ...state,
        quadrants: _updatedObservationMarkedQuadrant,
        tempQuadrant: [],
      };

    case ADD_TOOTH_OBSERVATION:
      const { observation: tooth_observation } = action?.payload;

      const _updatedMarkedTeethArray = state.markedTeeth.map((tooth) => {
        if (state.tempTeeth.includes(tooth.id)) {
          return {
            ...tooth,
            observation: tooth_observation,
            tooth_id: tooth.id, // if you still want to explicitly set this
          };
        }
        return tooth;
      });
      return {
        ...state,
        markedTeeth: _updatedMarkedTeethArray,
        tempTeeth: [],
      };
      break;
    case UPDATE_TOOTH_OBSERVATION:
      const { t_id, t_observation } = action.payload;

      const _updatedObservationMarkedTeeth = state.markedTeeth.map((tooth) => {
        if (state.tempTeeth.includes(tooth.id)) {
          return {
            ...tooth,
            observation: t_observation, // Update the observation for the specific tooth
          };
        }
        return tooth;
      });
      return {
        ...state,
        markedTeeth: _updatedObservationMarkedTeeth,
        tempTeeth: [],
      };

    case DELETE_QUADRANT_OBSERVATION:
      const quadrantIdentifier = action.payload;
      // Update the observation for the matching quadrant
      const updatedQuadrants = state.quadrants.map(
        (quadrant) =>
          quadrant.identifier === quadrantIdentifier
            ? { ...quadrant, observation: "" } // Clear the observation
            : quadrant // Keep other quadrants unchanged
      );
      return {
        ...state,
        quadrants: updatedQuadrants, // Update the quadrants array
      };

    case DELETE_TOOTH_OBSERVATION:
      const tooth_ID = action.payload;
      // Update the observation for the matching quadrant
      const updatedmarkedTeeth = state.markedTeeth.map(
        (tooth) =>
          tooth.id === tooth_ID
            ? { ...tooth, observation: "" } // Clear the observation
            : tooth // Keep other quadrants unchanged
      );
      return {
        ...state,
        markedTeeth: updatedmarkedTeeth, // Update the quadrants array
      };
    case RECORD_ADD_OR_UPDATE_TYPE:
      return {
        ...state,
        isRecordUpdate: action.payload,
      };
    case MARK_ALL_SELECTION:
      const updatedTempTeeth = state.markedTeeth.map((mark) => mark.id);
      return {
        ...state,
        tempTeeth: updatedTempTeeth,
      };
      break;

    case EDIT_TOOTH_OR_QUADRANT_OBSERVATION_FROM_LIST: {
      const { updateType, identifier } = action.payload;

      if (updateType === "tooth") {
        return {
          ...state,
          tempTeeth: [...state.tempTeeth, identifier],
        };
      }

      if (updateType === "quadrant") {
        return {
          ...state,
          tempQuadrant: [...state.tempQuadrant, identifier],
        };
      }

      return state; // fallback
    }

    case RESET_CURRENT_INDENTIFICATION_TEETH:
      return {
        ...state,
        markedTeeth: state.markedTeeth.map((tooth) =>
          state.tempTeeth.includes(tooth.id)
            ? {
                ...tooth,
                tooth_id: "", // Tooth ID (1-32)
                conditions: [],
                subConditions: [],
                observation: "",
                marked_completed: false,
              }
            : tooth
        ),
        tempTeeth: [],
      };

      break;
    case RESET_CURRENT_INDENTIFICATION_QUADRANT:
      return {
        ...state,
        quadrants: state.quadrants.map((quadrant) =>
          state.tempQuadrant.includes(quadrant.identifier)
            ? {
                ...quadrant,
                quadrant: "",
                conditions: [],
                observation: "",
                marked_completed: false,
                subConditions: [],
              }
            : quadrant
        ),
        tempQuadrant: [],
      };

      break;
    case RESET_ALL_SELECTION:
      return initialState;

    default:
      return state;
      break;
  }
}
